// Angular
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns Tyre Measurements string
 * example: 235-65-16
 */
@Pipe({ name: 'tyre_rim_measurement' })
export class TyreRimMeasurementPipe implements PipeTransform {

  /**
   * Transform
   * @param product: any
   */
  transform(product: any): any {
    const data = product?.context?.route;
    return `${data?.tyre_width}-${data?.tyre_aspect_ratio}-${data?.tyre_wheel_diameter_inches}`;
  }
}
